import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "@Shared/containers/form/commonMeta";

export interface ICommonReasonFormMeta {
  bankId: FormInputMeta;
  bank: FormInputMeta;

  schema: any;
}

const commonReasonFormMeta = {} as ICommonReasonFormMeta;

commonReasonFormMeta.bankId = {...BankIDInputMeta, name: 'bankId'};

commonReasonFormMeta.bank = {
  ...CorporateNameInputMeta,
  name: "bank",
  label: "Banque",
};


commonReasonFormMeta.schema = yup.object().shape(getValidationSchema(commonReasonFormMeta));

export default commonReasonFormMeta;